<template>
  <div>
    <v-flex xs12 sm12 md12>
      <Filters />
    </v-flex>
    <v-flex xs12 sm12 md12 class="align-content-end">
      <Actions />
    </v-flex>
    <v-flex xs12 sm12 md12>
      <v-container grid-list-md fluid fill-height>
        <v-layout wrap fill-height>
          <v-flex xs12 sm6 md3>
            <Tabs />
          </v-flex>
          <v-flex xs12 sm6 md5>
            <!-- <TabsTasks v-if="userCS && userCS !== null && userCS.id"/> -->
            <TabsTasks />
            <!-- <material-card color="success" title="Tickets" text="Tickets abertos pelo membro" v-if="userCS && userCS.id">
                            Esse membro não possui tickets abertos
                        </material-card>
                        <material-card color="info" title="Histórico de Atendimento" text="Histórico de Atendimento Huggy" v-if="userCS && userCS.id">
                            Esse membro não possui histórico de interação.
                        </material-card> -->
          </v-flex>
          <v-flex xs12 sm6 md4>
            <!-- <ConsumerUnitsTab/> -->
            <ConsumerUnitTabs />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </div>
</template>
<script>
import Filters from "../../components/cs/Filters";
// import Customer from '../../components/cs/Customer'

import Tabs from "../../components/cs/Tabs";
import TabsTasks from "../../components/cs/tasks/Tabs";
// import ConsumerUnits from '../../components/cs/ConsumerUnits'
import ConsumerUnitTabs from "../../components/cs/consumerunit/Tabs";
import Actions from "../../components/cs/Actions";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("cs", ["userCS, filters"]),
  },
  components: {
    Filters,
    //   Customer: Customer,
    Tabs,
    ConsumerUnitTabs,
    Actions,
    TabsTasks,
  },
};
</script>
